var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInboxLine = function SvgInboxLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.9 3.9h16.2a.9.9 0 0 1 .9.9v14.4a.9.9 0 0 1-.9.9H3.9a.9.9 0 0 1-.9-.9V4.8a.9.9 0 0 1 .9-.9m15.3 9.9h-3.074a4.501 4.501 0 0 1-8.252 0H4.8v4.5h14.4zm0-1.8V5.7H4.8V12h4.5a2.7 2.7 0 0 0 5.4 0z"
  })));
};
export default SvgInboxLine;